// js
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classnames from 'classnames';


const DSATabLink = ({pathname, name, title, baseNavRoute}) => {
  let tabUrl = `${baseNavRoute}/${name}`;
  const active = pathname.includes(`/${name}`);
  const classNames = classnames({
    active,
    [`nav-${title.replace(' ', '-').toLowerCase()}`]: true
  });

  return (
    <Link
      to={tabUrl}
      className={classNames}
      title={title}
    >
      {title}
    </Link>
  );
};

DSATabLink.propTypes = {
  pathname: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  baseNavRoute: PropTypes.string.isRequired
};

export default DSATabLink;



// WEBPACK FOOTER //
// ./src/components/DSATabLink.js